import { BPM_MAX, BPM_MIN, MASTER_VOLUME_MAX } from "../audio/constants";
import { clamp } from "./math";

/** Master volume is clamped in the store, so no code path can exceed the ceiling. */
export function clampMasterVolume(value: number): number {
  return clamp(value, 0, MASTER_VOLUME_MAX);
}

export function clampBpm(value: number): number {
  return Math.round(clamp(value, BPM_MIN, BPM_MAX));
}

/** Genre sliders are 0..100; normalisation to 1.0 happens in the engine. */
export function clampGenre(value: number): number {
  return Math.round(clamp(value, 0, 100));
}

/** Generic 0..1 control value. */
export function clampUnit(value: number): number {
  return clamp(value, 0, 1);
}

export function isNonEmptyString(value: unknown): value is string {
  return typeof value === "string" && value.length > 0;
}
